import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as employeeFragments from '../../../employees/gql/fragments'

export const DOC = gql`
  ${employeeFragments.employee.DOC}
  fragment FragmentResponsiblePerson on SpaceResponsiblePerson {
    id
    isPrimary
    employee {
      ...FragmentSpaceEmployee
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentResponsiblePersonFragment,
  ents.extra.space.Record.ResponsiblePerson
>({
  employee: graphql.transformers.OUT.nonNull(
    employeeFragments.employee.TRANSFORMER,
  ),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Record.ResponsiblePerson.Id.isId,
  ),
  isPrimary: transformers.PASS_THROUGH,
})
